const Cookies = () => {

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    // Cookies popup 

    const cookiesWrapper = document.getElementsByClassName('cookies-box')[0];
    const cookiesAccept  = document.getElementsByClassName('cookies-box__close')[0];

    if(cookiesWrapper) {
        setTimeout(() => {
            cookiesWrapper.classList.add('show');
        }, 3000);
    }
    if(cookiesAccept) {
        cookiesAccept.addEventListener('click',function() {
            cookiesWrapper.classList.remove('show');

            setCookie('zdrowie-cookies','cookieValue',7);
        })
    }

    const exitPopUp = document.getElementsByClassName('exit-popup')[0];
    const exitPopupForm = document.querySelector('.exit-popup form');
    const closePopup = document.getElementsByClassName('exit-popup__wrapper-close')[0];

    if(exitPopUp) {
        setTimeout(() => {
            exitPopUp.classList.add('show');
        }, 10000);
        exitPopUp.addEventListener('click',function(target) {
            console.log(target.target)
            if(target.target.classList.contains('exit-popup')) {
                exitPopUp.classList.remove('show');
                setCookie('exit-popup','cookieValue',2);
            }

        })
    }

    if(exitPopupForm) {
        exitPopupForm.addEventListener('submit',function() {
            exitPopUp.classList.remove('show');
            setCookie('exit-popup','cookieValue',2);
        })
    }

    if(closePopup) {
        closePopup.addEventListener('click', function() {
            exitPopUp.classList.remove('show');
            setCookie('exit-popup','cookieValue',2);
        })
    }

}

export default Cookies;